import { getContext } from '@/context';

type SdkEventType = 'OpenRegistrationScreen' | 'OpenOfferScreen';

type PublishSdkEventParams = {
  event: SdkEventType;
  data?: Record<string, unknown>;
};

export const publishSdkEvent = ({
  event,
  data = {},
}: PublishSdkEventParams): void => {
  try {
    getContext().handlers.publishEvent({ event, data });
  } catch {
    // Silent fail - SDK event publishing is non-critical
  }
};
